export default "__VITE_ASSET__f6511ae1__"